"use client";
import { Button } from "@/components/button";
import { FormMessage } from "@/components/form-message";
import { Controller } from "react-hook-form";
import { FaArrowRight, FaSpinner } from "react-icons/fa6";
import { useCtaForm } from "./hook/use-cta-form";

export function CtaForm({ label }: { label: string }) {
  const { control, onSubmit, isSubmitting, errors, message } = useCtaForm();

  return (
    <form
      onSubmit={onSubmit}
      className="relative flex flex-col justify-center lg:justify-start items-center lg:items-start gap-4 col-span-4 lg:col-span-2 w-full"
    >
      <Controller
        name="email"
        control={control}
        defaultValue=""
        render={({ field: { name, onChange, value } }) => (
          <>
            <label
              htmlFor={name}
              className="block w-full text-secondary text-lg lg:text-2xl lg:text-left text-center"
            >
              {label}
            </label>
            <div className="flex lg:flex-row flex-col justify-between lg:items-center gap-2 bg-white px-3 py-2 border border-transparent rounded-lg ring-1 ring-transparent hover:ring-2 hover:ring-primary focus-within:ring-2 focus-within:ring-primary w-full overflow-hidden transition-all duration-300">
              <input
                id={name}
                name={name}
                value={value}
                onChange={onChange}
                type="text"
                placeholder="Informe seu e-mail"
                className="flex-1 lg:col-span-3 bg-transparent disabled:opacity-50 py-2 outline-none lowercase disabled:cursor-no-drop"
                autoCapitalize="off"
                autoComplete="off"
                autoCorrect="off"
                disabled={isSubmitting}
              />
              <Button
                variant="contained"
                className="group overflow-hidden"
                disabled={isSubmitting}
              >
                {!isSubmitting ? (
                  <>
                    Enviar{" "}
                    <FaArrowRight className="hidden lg:block -mr-9 group-hover:mr-0 ml-2 transition-all duration-300" />
                  </>
                ) : (
                  <>
                    Enviando <FaSpinner className="animate-spin" />
                  </>
                )}
              </Button>
            </div>
          </>
        )}
      />
      {errors?.email && <FormMessage message={errors?.email?.message} />}
      {message && <FormMessage message={message} />}
    </form>
  );
}
